//import dayjs from "dayjs"
//import { cache, context, db as dbUtils, logging } from "@budibase/backend-core"
import { logging } from "@budibase/backend-core"
import { BBRequest } from "@budibase/types"

// const { DocWritethrough } = cache.docWritethrough
//
// function getLogDocId() {
//   return `${dbUtils.DocumentType.SCIM_LOG}${dbUtils.SEPARATOR}${dayjs().format(
//     "YYYYMMDD"
//   )}`
// }

// const getDB = async () => {
//   const dbName = context.getScimDBName()
//
//   return new DocWritethrough(dbUtils.getDB(dbName), getLogDocId())
// }

export async function logRequest(request: BBRequest<any>) {
  logging.logWarn("SCIM request log", request)
  // const logId = Date.now().toString()
  // const writethrough = await getDB()
  // await writethrough.patch({
  //   [`${logId}_request`]: {
  //     ts: new Date().toISOString(),
  //     ...request,
  //   },
  // })
  // return logId
}

export async function logResponse(response: any) {
  // log to console for now
  logging.logWarn(`SCIM response error`, response)
  // const writethrough = await getDB()
  // await writethrough.patch({
  //   [`${logId}_response`]: {
  //     ts: new Date().toISOString(),
  //     ...response,
  //   },
  // })
}
